<!--
 * @Description:
 * @Author: JDY
 * @Date: 2021-04-07 12:00:03
 * @LastEditTime: 2021-04-29 15:41:11
 * @LastEditors: JDY
-->
<template>
  <a-dropdown placement="bottomRight">
    <span class="ant-pro-account-avatar">
      <a-avatar size="small" :src="globalUrl + avatar" class="antd-pro-global-header-index-avatar" />
      <span>{{ userInfo.username }}</span>
    </span>
    <template v-slot:overlay>
      <a-menu class="ant-pro-drop-down menu" :selected-keys="[]">
        <a-menu-item v-if="menu" key="center" @click="handleToCenter">
          <a-icon type="user" />
          个人中心
        </a-menu-item>
        <a-menu-divider v-if="menu" />
        <a-menu-item key="logout" @click="handleLogout">
          <a-icon type="logout" />
          退出登录
        </a-menu-item>
      </a-menu>
    </template>
  </a-dropdown>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { Modal } from 'ant-design-vue'

export default {
  name: 'AvatarDropdown',
  props: {
    currentUser: {
      type: Object,
      default: () => null
    },
    menu: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters(['username', 'avatar', 'name', 'userInfo'])
  },
  methods: {
    ...mapActions(['Logout']),
    handleToCenter () {
      this.$router.push({ path: '/account/center' })
    },
    handleLogout (e) {
      const { Logout } = this
      Modal.confirm({
        title: this.$t('提示'),
        content: this.$t('确定退出登录？'),
        cancelText: '取消',
        okText: '确定',
        onOk: () => {
          Logout()
            .then(() => {
              setTimeout(() => {
                window.location.reload()
              }, 500)
            })
            .catch(err => console.log(err))
            .finally(() => {})
        },
        onCancel () {}
      })
    }
  }
}
</script>

<style lang="less" scoped>
.ant-pro-drop-down {
  /deep/ .action {
    margin-right: 8px;
  }
  /deep/ .ant-dropdown-menu-item {
    min-width: 160px;
  }
}
</style>
